/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
export const handleKeyDown = (event:any) => {
  if (event.key === 'Enter') {
    event.preventDefault();
  }
};

export const isValidJSON = (str:any) => {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
};

export const isValidString = (str: any) => {
  return typeof str === 'string';
};

export const getPrettierMessage = (msg: any) => {
  let prettierMessage = '';
  if (isValidJSON(msg)) {
    let objMessage = JSON.parse(msg);
    if (objMessage?.hasOwnProperty('Message') || objMessage?.hasOwnProperty('message')){
      let propMessage = objMessage.Message || objMessage.message;
      if (isValidString(propMessage) && !isValidJSON(propMessage)) {
        prettierMessage = propMessage;
      }
    }
  } else if(isValidString(msg)) {
    prettierMessage = msg; 
  }
  return prettierMessage;
};


const normalizeByType = (data:any) => {
  let normalizedData:any = null;
  if (Array.isArray(data)) {
    normalizedData = normalizeArray(data);
  } else if(typeof data === 'object'){
    normalizedData = normalizeObject(data);
  } else {
    normalizedData = data;
  }
  return normalizedData;
};

const normalizeArray = (data:any) => {
  return data.map((it:any) => {
    let itemParsed = normalizeByType(it);
    return itemParsed;
  });
};

const normalizeObject = (data:any) => {
  let normalizedData  = Object.fromEntries(
    Object.entries(data).map(([key, value]) => [key.toLowerCase(), normalizeByType(value)])
  );
  return normalizedData;
};

// Convert all keys to lowercase
export const normalized = (data:any)=> {
  let normalizedData:any = normalizeByType(data);
  return normalizedData;
}

export const sendEventToParent = (event:any, data:any = null) => {
  window.parent.postMessage({
    event_id: event,
    data
  }, '*');
};

export const cleanRepeatElements = (stringList: any) => {
  let filterData = stringList?.filter((item:any, index:number)=>{
    return stringList.indexOf(item) === index;
  }) || [];
  return filterData;
};

export const getSortedList = (list:any) => {
  let options = [...list];
  if (options && options.length > 0) {
    options.sort((optA:any, optB:any) => optA?.label?.localeCompare(optB?.label));
  }
  return options;
};

export const tryParseToSlug = (label:string) => {
  try {
    if (label) {
      let slug = label
        ?.toLocaleLowerCase()
        ?.trim()
        ?.normalize('NFD')
        ?.replace(/[\u0300-\u036f]/g, '')
        ?.replace(/\s+/g, "-")
        ?.replace(/[^\w\-]+/g, "")
        ?.replace(/\-\-+/g, "-")
        ?.replace(/^-+/, "")
        ?.replace(/-+$/, "");
      return slug;
    } else {
      throw new Error("Empty label string");
    }
  } catch(err: any) {
    console.log("tryParseToSlug err: ", err);
    return label;
  }
};